export enum PaymentSubscriptionStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  INACTIVE = 'INACTIVE',
  TRIAL = 'TRIAL',
}

export interface PaymentSubscription {
  status: PaymentSubscriptionStatus;
  created_at: string;
  cancelled_at?: string | null;
  // Last day of validity of the subscription or trial if it is active
  // Value is null or undefined if the trial is false and there was never a subscription
  valid_until?: string | null;
}
